import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'

export default {
    async [actionTypes.FONTE_FINANCIAMENTO.BUSCAR_FONTES_FINANCIAMENTO](context, filtro) {
        const {data} = await api.fonteFinanciamento.buscarFontesFinanciamento(filtro)
        return data
    }
}
